module.exports = __webpack_public_path__ + "img/LighthouseSiegeScreenshot3_1920x1080.fedd5556.png";